module.exports = __webpack_public_path__ + "static/media/closeResponsive.1d3eb18a.svg";